import { useTranslation } from 'react-i18next';
import {
  Core,
  // IconCategoryValue
} from '@everfi/reactifi';
import { LinkBox, LinkOverlay } from '@chakra-ui/react';

const ExploreMoreItem = props => {
  const { t } = useTranslation();
  return (
    <Core.Layout variant="flex" flexDirection="row" gap="md" justifyContent="stretch" flex="1">
      <LinkBox>
        <Core.Card direction="row" size="sm">
          <Core.Image path={props.playlistImage} width="128" objectFit="contain" />
          <Core.CardBody>
            <Core.Layout
              variant="flex"
              flexDirection="column"
              justifySelf="stretch"
              justifyContent="space-between"
              h="full"
              // p='sm' don't need this if we remove stack from card body
            >
              <LinkOverlay href="#">
                <Core.Typography as="h3" textStyle="h4" style={{ margin: 0 }}>
                  {t(props.playlistTitle)}
                </Core.Typography>
              </LinkOverlay>
              {/* <IconCategoryValue icon="clock" value="8 minutes" /> */}
            </Core.Layout>
          </Core.CardBody>
        </Core.Card>
      </LinkBox>
    </Core.Layout>
  );
};
export default ExploreMoreItem;
